import React, { useEffect, useState } from "react";
import { Row, Button, Modal, Col } from "antd";
import { useAsyncAxios, utilAxiosWithAuth } from "../utils/customAxios";
import { useAlert } from "../provider/AlertProvider";

import * as Common from "../commons/common";
import * as Request from "../commons/request";
import * as TypeDTO from "../commons/typeDTO";
import * as Utils from "../utils/utils";

import deleteCarImg from "../assets/images/deleteCar.svg";
import styles from "./ManageCar.module.css";
import CarList from "../components/CarList";
import PageContainer from "../layout/PageContainer";

function ManageCar() {
    const alert = useAlert();

    const [isDelete, setIsDelete] = useState(false);
    const [changeActiveCar, setChangeActiveCar] = useState("");
    const [deleteCarList, setDeleteCarList] = useState<Array<number>>([]);
    const [myCars, setMyCars] = useState<Array<TypeDTO.CarOwnerDto>>();
    const [openModalConfirmDeleteCars, setOpenModalConfirmDeleteCars] = useState(false);

    useEffect(() => {
        requestGetMyCars();
    }, []);

    useEffect(() => {
        Utils.onEvent(Common.EVENT_CLOSE_ALL_MODAL, handleCloseAllModal);

        return () => {
            Utils.offEvent(Common.EVENT_CLOSE_ALL_MODAL, handleCloseAllModal);
        };
    }, []);

    const handleDeleteBtnClick = () => {
        if (deleteCarList.length === 0) {
            alert.setAlert("", "삭제 실패", "삭제하실 차량을 선택해 주세요.");
            return;
        }
        setOpenModalConfirmDeleteCars(true);
    };

    useEffect(() => {
        openModalConfirmDeleteCars ? Utils.addModalStack() : Utils.popModalStack();
    }, [openModalConfirmDeleteCars]);

    const requestAxiosGetMyCars = async () => {
        const response = await utilAxiosWithAuth().get(Request.OWNERS_MINE_URL);
        return response.data;
    };

    const {
        loading: loadingGetMyCars,
        error: errorGetMyCars,
        data: resultGetMyCars,
        execute: requestGetMyCars,
    } = useAsyncAxios(requestAxiosGetMyCars);

    useEffect(() => {
        if (!resultGetMyCars) return;
        console.log("resultGetMyCars", resultGetMyCars);

        setMyCars(resultGetMyCars.carOwners);
    }, [resultGetMyCars]);

    useEffect(() => {
        if (!errorGetMyCars) return;

        console.log("errorGetMyCars", errorGetMyCars);
    }, [errorGetMyCars]);

    const requestAxiosDeleteCar = async (carOwnerId: number) => {
        const response = await utilAxiosWithAuth().delete(Request.CAR_OWNERS + "/" + carOwnerId);
        return response.data;
    };

    const {
        loading: loadingDeleteCar,
        error: errorDeleteCar,
        data: resultDeleteCar,
        execute: requestDeleteCar,
    } = useAsyncAxios(requestAxiosDeleteCar);

    useEffect(() => {
        if (!resultDeleteCar) return;
        console.log("resultDeleteCar", resultDeleteCar);
        setIsDelete(false);
        requestGetMyCars();
    }, [resultDeleteCar]);

    useEffect(() => {
        if (!errorDeleteCar) return;

        console.log("errorDeleteCar", errorDeleteCar);
    }, [errorDeleteCar]);

    const [openModalConfirmActiveCars, setOpenModalConfirmActiveCars] = useState(false);

    useEffect(() => {
        openModalConfirmActiveCars ? Utils.addModalStack() : Utils.popModalStack();
    }, [openModalConfirmActiveCars]);

    const requestAxiosUpdateActiveCar = async (carOwner: TypeDTO.CarOwnerDto) => {
        const response = await utilAxiosWithAuth().put(Request.CAR_OWNERS + "/" + carOwner.carOwnerId, carOwner);

        return response.data;
    };

    const {
        loading: loadingUpdateActiveCar,
        error: errorUpdateActiveCar,
        data: resultUpdateActiveCar,
        execute: requestUpdateActiveCar,
    } = useAsyncAxios(requestAxiosUpdateActiveCar);

    useEffect(() => {
        if (!resultUpdateActiveCar) return;
        console.log("resultUpdateActiveCar", resultUpdateActiveCar);

        requestGetMyCars();
    }, [resultUpdateActiveCar]);

    useEffect(() => {
        if (!errorUpdateActiveCar) return;

        console.log("errorUser", errorUpdateActiveCar);
    }, [errorUpdateActiveCar]);

    const handleCloseAllModal = () => {
        setOpenModalConfirmDeleteCars(false);
        setOpenModalConfirmActiveCars(false);
    };

    const onDeleteCars = () => {
        deleteCarList.forEach((carId) => {
            const deleteCars = myCars?.filter((myCar) => myCar.car.carId === carId);
            if (deleteCars !== null && deleteCars !== undefined && deleteCars.length > 0) {
                const deleteCar = deleteCars[0];
                requestDeleteCar(deleteCar.carOwnerId);
            }
        });
    };

    const onActiveCar = (carNumber: string) => {
        setChangeActiveCar(carNumber);
        setOpenModalConfirmActiveCars(true);
    };

    const onChangeActiveCar = () => {
        const changeCars = myCars?.filter((myCar) => myCar.car.carNumber === changeActiveCar);
        if (changeCars && changeCars.length > 0) {
            const activeCar = { ...changeCars[0], active: true };
            requestUpdateActiveCar(activeCar);
        }
    };

    return (
        <PageContainer pageBackground={"white"} contentPadding={16}>
            <Row align="middle" justify="center">
                <div className="container">
                    <Row justify={"space-between"} className={styles.titleBody}>
                        <p>보유 차량</p>
                        <Button
                            disabled={isDelete || myCars === undefined || myCars?.length === 0}
                            type="text"
                            className={styles.deleteBtn}
                            onClick={() => {
                                if (myCars?.length !== 0) {
                                    setIsDelete(true);
                                }
                            }}
                        >
                            <img width={20} height={22} src={deleteCarImg} />
                        </Button>
                    </Row>

                    <>
                        {myCars?.length === 0 ? (
                            <CarList carNumber="" isActive={false} deleteCarList={deleteCarList} setDeleteCarList={setDeleteCarList} />
                        ) : (
                            myCars?.map((carInfo) => (
                                <CarList
                                    key={carInfo.car.carNumber}
                                    carId={carInfo.car.carId}
                                    carNumber={carInfo.car.carNumber}
                                    isActive={carInfo.active}
                                    onActiveCar={onActiveCar}
                                    isDelete={isDelete}
                                    deleteCarList={deleteCarList}
                                    setDeleteCarList={setDeleteCarList}
                                    isYaxing={carInfo.car.hasSwingDoor}
                                />
                            ))
                        )}
                    </>
                    <Row gutter={16}>
                        <Col className="gutter-row" span={12}>
                            <Button
                                block
                                className={styles.cancelBtn}
                                disabled={!isDelete}
                                onClick={() => {
                                    setIsDelete(false);
                                }}
                                loading={loadingDeleteCar}
                            >
                                취소
                            </Button>
                        </Col>
                        <Col className="gutter-row" span={12}>
                            <Button
                                block
                                className={styles.deleteCarBtn}
                                disabled={!isDelete}
                                onClick={handleDeleteBtnClick}
                                loading={loadingDeleteCar}
                            >
                                삭제하기
                            </Button>
                        </Col>
                    </Row>

                    <Modal
                        className="confirmModal"
                        centered
                        key="modalSmartkeyActionError"
                        open={openModalConfirmDeleteCars}
                        closable={false}
                        onCancel={() => setOpenModalConfirmDeleteCars(false)}
                        footer={[
                            <Button block key="back" onClick={() => setOpenModalConfirmDeleteCars(false)}>
                                닫기
                            </Button>,
                            <Button
                                block
                                danger
                                key="confirm"
                                onClick={() => {
                                    onDeleteCars();
                                    setOpenModalConfirmDeleteCars(false);
                                }}
                            >
                                확인
                            </Button>,
                        ]}
                    >
                        <div>정말 삭제 하시겠습니까?</div>
                    </Modal>

                    <Modal
                        className="confirmModal"
                        centered
                        key="modalChangeActiveCar"
                        open={openModalConfirmActiveCars}
                        closable={false}
                        onCancel={() => setOpenModalConfirmActiveCars(false)}
                        footer={[
                            <Button block key="back" onClick={() => setOpenModalConfirmActiveCars(false)}>
                                닫기
                            </Button>,
                            <Button
                                block
                                type="primary"
                                key="confirm"
                                onClick={() => {
                                    onChangeActiveCar();
                                    setOpenModalConfirmActiveCars(false);
                                }}
                            >
                                확인
                            </Button>,
                        ]}
                    >
                        <div className={styles.modalText}>
                            {changeActiveCar} 차량을
                            <br />
                            기본 차량으로 변경하시겠습니까?
                        </div>
                    </Modal>
                </div>
            </Row>
        </PageContainer>
    );
}

export default ManageCar;
